// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"53365415","453":"e77e7717"}[chunkId] + ".chunk.js";
};